import { render, staticRenderFns } from "./MyAttention.vue?vue&type=template&id=11d67237&scoped=true&"
import script from "./MyAttention.vue?vue&type=script&lang=js&"
export * from "./MyAttention.vue?vue&type=script&lang=js&"
import style0 from "./MyAttention.vue?vue&type=style&index=0&id=11d67237&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d67237",
  null
  
)

export default component.exports